export default "__VITE_ASSET__BYEmx3B0__"